import React from "react";
import { Box, Flex, HStack, useDisclosure } from "@chakra-ui/react";

import { useContextConsumer } from "modules/context/Providers/ContextProvider";
import { useIsUserLogged } from "modules/authentication/infrastructure/useIsUserLogged";

import { ContentArea } from "components/ContentArea";
import { DangerousInnerHtml } from "components/DangerousInnerHtml";

import { Logo } from "../Logo";
import { HamburgerIcon } from "./HamburgerIcon";
import SideDrawer from "./SideDrawer";
import { ProfileDropdown } from "../ProfileDropdown";
import { MobileAuthentication } from "./MobileAuthentication";

interface IProps {
  logoFileId?: number;
}

const MobileHeader = ({ logoFileId }: IProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { headHtml } = useContextConsumer();
  const isUserLogged = useIsUserLogged();

  return (
    <>
      <SideDrawer onClose={onClose} isOpen={isOpen} />
      <ContentArea
        minH="40px"
        p={5}
        display="flex"
        position="sticky"
        top={0}
        zIndex={100}
        alignItems="center"
        mb={4}
        flexDirection="column"
      >
        <Flex w="100%" alignItems="center">
          <Logo logoFileId={logoFileId} maxH="50px" maxW="90px" />
          <HStack spacing={2} ml="auto">
            {isUserLogged ? <ProfileDropdown /> : <MobileAuthentication />}
            <HamburgerIcon onOpen={onOpen} />
          </HStack>
        </Flex>
        <Box alignSelf="flex-start" w="100%">
          <DangerousInnerHtml html={headHtml} />
        </Box>
      </ContentArea>
    </>
  );
};

export { MobileHeader };
